import { Injector } from '@angular/core';

export let AppInjector: Injector;
export function setAppInjector(injector: Injector) {
    AppInjector = injector;
}